import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { SoleContact, SoleContactService } from 'taxtank-core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SoleContactFormDialogComponent } from '@client/sole/components/sole-contact-form-dialog/sole-contact-form-dialog.component';
import { AbstractAutocompleteComponent } from '../abstract-autocomplete/abstract-autocomplete.component';

/**
 * Sole contact autocomplete
 */
@Component({
  selector: 'app-sole-contact-autocomplete',
  templateUrl: './sole-contact-autocomplete.component.html',
  styleUrls: ['./sole-contact-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SoleContactAutocompleteComponent extends AbstractAutocompleteComponent<SoleContact> implements OnInit {
  protected dialog = inject(MatDialog);
  private soleContactService = inject(SoleContactService);

  @Input() label = 'Payer';
  @Input() placeholder = 'Select payer';
  @Input() minSearchLength = 0;
  @Input() canManage = true;
  @Input() searchBy = 'name';
  dialogComponent = SoleContactFormDialogComponent;

  getOptions$(): Observable<SoleContact[]> {
    return this.soleContactService.getArray();
  }
}
